var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F1C220"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0006 29.9986C23.2849 29.9986 30.0006 23.2829 30.0006 14.9986C30.0006 12.4171 29.3485 9.98786 28.2 7.8667C25.5627 5.56208 22.1114 4.16577 18.334 4.16577C10.0497 4.16577 3.33398 10.8815 3.33398 19.1658C3.33398 21.7473 3.98613 24.1765 5.13466 26.2977C7.77188 28.6023 11.2232 29.9986 15.0006 29.9986Z",
    fill: "#FFCC1D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_910_20667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.21 23.957C13.4481 24.0588 13.7249 23.9738 13.864 23.7541L20.1921 13.6995C20.2946 13.5367 20.3008 13.3312 20.2081 13.1634C20.1154 12.995 19.9382 12.8904 19.7462 12.8904H15.5228L17.0935 6.65689C17.1568 6.40506 17.0286 6.14498 16.7901 6.0425C16.5533 5.94054 16.2747 6.02601 16.1361 6.24538L9.80797 16.3001C9.70549 16.4628 9.69931 16.6683 9.79201 16.8362C9.88472 17.0046 10.0619 17.1091 10.254 17.1091H14.4774L12.9066 23.3426C12.8433 23.5945 12.9715 23.8546 13.21 23.957V23.957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_20667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 5.99976)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerUp);
export default __webpack_public_path__ + "static/media/power-up.e3d2de1f0bb09ffb683b96a7d62fe208.svg";
export { ForwardRef as ReactComponent };